module.exports = __webpack_public_path__ + "static/media/garden.45e8001c.mp3";